import * as React from 'react';
import SecondaryCustomizedTablesAdmin from './Element/ExpirationLicenseTable'

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export default function ExpirationLicenseTable() {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
        </Grid>
        <Grid item xs={12} sm={12} md={7} lg={7}>
          <SecondaryCustomizedTablesAdmin />
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5}>
        </Grid>
      </Grid>
    </Box>
  );
}